// DOM event methods live on the prototype and are lost when spreading a press event.
export function createPressContextMenuEvent(sourceEvent) {
  return {
    ...sourceEvent,
    handled: true,
    type: "contextmenu",
    preventDefault: () => sourceEvent.preventDefault(),
    stopPropagation: () => sourceEvent.stopPropagation()
  };
}
